var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "create-dialog",
      attrs: {
        visible: _vm.dialogVisible,
        "before-close": _vm.handleClose,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body create-body" }, [
            _c("form", { staticClass: "flex" }, [
              _c(
                "div",
                {
                  staticClass: "form-group small-width inline-block",
                  staticStyle: { "padding-right": "10px" }
                },
                [
                  _c("el-input", {
                    staticClass: "form-control inline-block",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      "prefix-icon": "el-icon-search",
                      size: "small",
                      placeholder: "搜索医生"
                    },
                    model: {
                      value: _vm.filterText,
                      callback: function($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "line-height": "24px", height: "24px" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "ft-l smallCheckbox",
                          staticStyle: { "margin-right": "5px" },
                          attrs: { indeterminate: _vm.isIndeterminate },
                          on: { change: _vm.addAllPeopleChange },
                          model: {
                            value: _vm.checkAll,
                            callback: function($$v) {
                              _vm.checkAll = $$v
                            },
                            expression: "checkAll"
                          }
                        },
                        [_vm._v("所有医生")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "list-group",
                      attrs: { id: "createPeopleList" }
                    },
                    _vm._l(_vm.allUserList, function(item, key) {
                      return _c(
                        "div",
                        { key: key },
                        [
                          _c(
                            "el-checkbox",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.depBoxShow(item.users),
                                  expression: "depBoxShow(item.users)"
                                }
                              ],
                              staticClass: "margin-tb-5",
                              attrs: { indeterminate: item.isIndeterminate },
                              on: {
                                change: function($event) {
                                  return _vm.depCheckAllChange(key, $event)
                                }
                              },
                              model: {
                                value: item.checkAll,
                                callback: function($$v) {
                                  _vm.$set(item, "checkAll", $$v)
                                },
                                expression: "item.checkAll"
                              }
                            },
                            [_vm._v(_vm._s(key))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox-group",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.depCheckGroup(key, item.checkList)
                                }
                              },
                              model: {
                                value: item.checkList,
                                callback: function($$v) {
                                  _vm.$set(item, "checkList", $$v)
                                },
                                expression: "item.checkList"
                              }
                            },
                            _vm._l(item.users, function(val, i) {
                              return _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        val.userName.indexOf(_vm.filterText) >
                                        -1,
                                      expression:
                                        "val.userName.indexOf(filterText)>-1"
                                    }
                                  ],
                                  key: i,
                                  staticClass: "list-group-item checkbox"
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        label: val,
                                        disabled: val.id === _vm.myUserId
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: val.avatarImageUrl
                                            ? val.avatarImageUrl
                                            : require("../../../static/avatar.jpg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "user-name" }, [
                                        _vm._v(_vm._s(val.userName))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "form-group large-width inline-block float-r pd-10 bg-F7F8FA relative"
                },
                [
                  _c("div", { staticStyle: { height: "calc(100% - 46px)" } }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("添加群成员：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fs-12 color-86909c peopleNum" }, [
                      _vm._v("已选择" + _vm._s(_vm.checkList.length) + "人")
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "list-group",
                        attrs: { id: "createAddPeopleList" }
                      },
                      [
                        _vm.selfData
                          ? _c("div", [
                              _c(
                                "li",
                                {
                                  staticClass: "list-group-item flex",
                                  staticStyle: { "line-height": "45px" }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.selfData.user.avatarImageUrl
                                        ? _vm.selfData.user.avatarImageUrl
                                        : require("../../../static/avatar.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text" }, [
                                    _c("strong", { staticClass: "user-name" }, [
                                      _vm._v(_vm._s(_vm.selfData.user.userName))
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.allUserList, function(item, key) {
                          return item.checkList.length > 1 ||
                            (item.checkList.length === 1 &&
                              item.checkList[0].id !== _vm.myUserId)
                            ? _c(
                                "div",
                                { key: key },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "line-height": "24px" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "fs-12 color-86909c" },
                                        [_vm._v(_vm._s(key))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(item.checkList, function(val, index) {
                                    return val.id !== _vm.myUserId
                                      ? _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass: "list-group-item flex",
                                            staticStyle: {
                                              "line-height": "45px"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: val.avatarImageUrl
                                                  ? val.avatarImageUrl
                                                  : "../../../static/avatar.jpg"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "text" }, [
                                              _c(
                                                "strong",
                                                { staticClass: "user-name" },
                                                [_vm._v(_vm._s(val.userName))]
                                              ),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "iconfont icon-shanchu-fill cursor ft-r mr-5",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteChoose(
                                                      key,
                                                      val.id
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.peopleModalType === "create"
                    ? _c(
                        "div",
                        { staticClass: "create-roomName" },
                        [
                          _c("label", { attrs: { for: "create-room-name" } }, [
                            _vm._v("房间名：")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "form-control inline-block",
                            attrs: {
                              size: "small",
                              id: "create-room-name",
                              placeholder: "请输入房间名称"
                            },
                            model: {
                              value: _vm.roomName,
                              callback: function($$v) {
                                _vm.roomName = $$v
                              },
                              expression: "roomName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer fl-r",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.saveCreate }
            },
            [_vm._v("确 定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("关 闭")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89188376", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89188376","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/createGroup.vue
// module id = null
// module chunks = 